<template>
	<div class="step-wrapper">
		<div class="step-lines">
			<hr
				class="completed secondary-border"
				:style="{'width': ((this.step - 1)/(this.steps.length - 1)) * 100 + '%'}"
			/>
			<hr
				class="remaining"
				:style="{'width': (1 - (this.step - 1)/(this.steps.length - 1)) * 100 + '%'}"
			/>
		</div>
		<ul class="step-breadcrumb">
			<li
				class="crumb"
				v-for="step_item in steps"
				:class="{ active: step == step_item.step, completed: step > step_item.step }"
				@click="view_step(step_item.step)"
			>
				<div class="step-number">
					<span class="check" :class="{ 'secondary-border': (step > step_item.step), 'secondary-background': (step > step_item.step) }">&check;</span>
					<span class="number" :class="{ 'primary-border': (step == step_item.step), 'primary-background': (step == step_item.step) }">{{step_item.step}}</span>
					<div class="inner-step-name">
						<span class="name" :class="{ 'primary-color': (step == step_item.step), 'secondary-color': (step > step_item.step) }">{{getText(step_item.name)}}</span>
					</div>
				</div>
				<div class="step-name" :class="{ 'primary-color': (step == step_item.step) }">
					<span class="name">{{step_item.name}}</span>
				</div>
			</li>
		</ul>
	</div>
</template>

<script>
// Language / Localization
import LanguageService from "@/common/language.service";

export default {
	name: "StepBreadcrumb",
	props: {
		step: Number
	},
	data() {
		return {
			steps: [
				{ step: 1, name: "StepInvoice" },
				{ step: 2, name: "StepBilling" },
				{ step: 3, name: "StepPayment" },
				{ step: 4, name: "StepReview" }
			]
		};
	},
	methods: {
		getText(key){
			return LanguageService.getText(key);
		},
		// Only backwards stepping allowed
		view_step: function(step) {
			if (step < this.step) this.$emit("change", step);
		}
	}
};
</script>

<style scoped lang="scss">
@import "node_modules/bootstrap/scss/functions";
@import "node_modules/bootstrap/scss/variables";
@import "node_modules/bootstrap/scss/mixins/_breakpoints";

.step-wrapper {
	position: relative;
}

.step-lines {
	display: flex;
	margin: 0 20px;

	.completed {
	}
	.remaining {
		border-color: #e3e3e3;
	}
}
.step-breadcrumb {
	padding-left: 0px;
	margin-top: -52px;
	margin-bottom: 50px;
	display: flex;
	justify-content: space-between;

	.crumb {
		font-size: 14px;
		color: #666;
		display: flex;
		&.active {
			.step-number {
				&:before {
					background-color: #b9e6fa;
				}

				.inner-step-name {
					.name {
						
					}
				}

				.number {
					color: white;
				}
			}
			.step-name {
				
			}
		}

		&.completed {
			&:hover {
				cursor: pointer;

				.step-number {
					.check {
						color: white;
					}

					.inner-step-name {
						.name {
							color: #b9e6fa;
						}
					}
				}
				.step-name {
				}
			}

			.step-number {
				&:before {
					background-color: #b9e6fa;
				}

				.check {
					display: inline-block;
					color: white;
				}
				.number {
					display: none;
				}

				.inner-step-name {
					.name {
					}
				}
			}
			.step-name {
				color: #b9e6fa;
			}
		}

		.step-number {
			display: flex;
			flex-flow: column wrap;
			align-items: center;
			position: relative;

			.inner-step-name {
				.name {
					display: block;
					text-align: center;
					font-weight: bold;
					margin-top: 10px;
					color: #c4c4c4;
				}
			}

			.check {
				display: none;
			}

			.check,
			.number {
				position: relative;
				border: 2px solid #ebebeb;
				width: 40px;
				height: 40px;
				line-height: 38px;
				font-size: 15px;
				font-weight: bold;
				border-radius: 20px;
				text-align: center;
				color: #c4c4c4;
				background: #f6f6f6;
				z-index: 999;
			}

			.number {
				display: inline-block;
			}
		}

		.step-name {
			font-weight: bold;
			margin-top: 10px;
			color: #c4c4c4;
			display: none;
		}
	}
}
</style>
